// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"acba14a5","436":"7d32feeb","453":"f394a27d","501":"9ff43898","606":"f8225ced","821":"d230aab1","925":"56b99fbb","969":"f435856f"}[chunkId] + ".chunk.js";
};